import React from 'react';
import './terms.css'; // Custom CSS for styling
import { useNavigate } from 'react-router-dom';
import GameHeader from '../header/header';

const Terms = () => {
    const navigate = useNavigate();

    const handleAdminlogin = () => {
        window.history.back();
        // navigate(`/`);
    };
    return (
        <div className="obtibg">
                <GameHeader />
                <div className="terms-container">
                    <div className="terms-content">
                        <h1>Terms and Conditions</h1>
                        <p>Please read the following updated Terms and Conditions carefully. By using our platform, you agree to abide by these terms. Thank you for your cooperation.</p>

                        <h2>1. Account Usage and Withdrawals</h2>
                        <p>1.1. All Games must be completed before initiating a withdrawal or resetting your account.</p>

                        <h2>2. Account Registration</h2>
                        <p>2.1. Only one account is allowed per phone number. Multiple accounts registered under the same phone number will be deactivated.</p>

                        <h2>3. Wallet Address Binding</h2>
                        <p>3.1. It is strictly prohibited to bind the same wallet address to different accounts. If we detect this activity, we reserve the right to freeze the related accounts.</p>

                        <h2>4. Account Security</h2>
                        <p>4.1. Please ensure that you do not disclose your account password and withdrawal password to anyone else. Our platform will not be held responsible for any damages resulting from unauthorized access to your account.</p>

                        <h2>5. Low Exposure Game</h2>
                        <p>5.1. Low Exposure Games are randomly allocated by the system. Each Low Exposure Game includes 1-3 Games. Once accepted and allocated, changes or cancellations are strictly not allowed.</p>

                        <h2>6. Inappropriate Use of Account</h2>
                        <p>6.1. In the event of inappropriate use of your account, we reserve the right to take legal action against you.</p>

                        <h2>7. Deposit Confirmation</h2>
                        <p>7.1. Before transferring funds, kindly confirm the deposit address with our customer service to ensure accuracy.</p>

                        <h2>8. Wrong Deposit Address</h2>
                        <p>8.1. The platform will not assume any responsibility if a deposit is made to the wrong address. Please verify the address before making a deposit.</p>

                        <h2>9. Minimum Balance Requirement</h2>
                        <p>9.1. Members must have a minimum balance of USDC 70 before starting an Optimization.</p>

                        <h2>10. Optimization Completion</h2>
                        <p>10.1. Once you start to optimize Games, it must be completed within one day. If you anticipate being unable to complete it, please inform our customer service.</p>

                        <p className="closing">Dear agent, please take the time to read and understand our updated Terms and Conditions. Your cooperation is greatly appreciated.</p>
                    </div>
                </div>
        </div>
    );
};

export default Terms;
